import React from "react";
import { Link } from "react-router-dom";
import "../styles/Portfolio.css";
import { useLanguage } from "../contexts/LanguageContext";
import { track } from "../utils/analytics";

const Portfolio = () => {
  const { language, text } = useLanguage();
  const isHeb = language === "he";
  const p = text.portfolio;

  const labels = isHeb
    ? { problem: "הבעיה", solution: "מה בנינו", result: "התוצאה" }
    : { problem: "Problem", solution: "What we built", result: "Result" };

  return (
    <section id="work" className="portfolio-section" dir={isHeb ? "rtl" : "ltr"}>
      <span className="eyebrow">{p.eyebrow}</span>
      <h2 className="section-title">{p.title}</h2>
      <p className="portfolio-lede">{p.lede}</p>

      <div className="portfolio-grid">
        {p.items.map((item) => (
          <Link
            to={`/work/${item.slug}`}
            key={item.key}
            className="case-card"
            onClick={() => track("case_card_click", { slug: item.slug })}
          >
            <div className="case-card-top">
              <span className="case-tag">{item.tag}</span>
              <h3 className="case-title">{item.title}</h3>
            </div>

            <ul className="case-list">
              <li>
                <span className="case-label">{labels.problem}</span>
                <span className="case-text">{item.problem}</span>
              </li>
              <li>
                <span className="case-label">{labels.solution}</span>
                <span className="case-text">{item.solution}</span>
              </li>
              <li className="case-result-row">
                <span className="case-label case-label-result">
                  {labels.result}
                </span>
                <span className="case-result">{item.result}</span>
              </li>
            </ul>

            <div className="case-stack">
              {item.stack.map((s) => (
                <span key={s} className="case-stack-chip">
                  {s}
                </span>
              ))}
            </div>

            <span className="case-arrow" aria-hidden="true">
              {p.cta}
              <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2.2">
                <path d="M5 12h14M13 5l7 7-7 7" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
};

export default Portfolio;
